module.exports = __webpack_public_path__ + "img/国内合作医院.ede44b82.png";